import { format, isValid, subMinutes } from 'date-fns';

const castDateStringAsUTC = (date) => {
  let replaced = String(date).replace(/-/g, '/');
  const cleanDate = date && isValid(new Date(replaced)) ? replaced : new Date();
  return format(subMinutes(new Date(cleanDate), new Date(cleanDate).getTimezoneOffset()), 'yyyy-MM-dd HH:mm:ss');
};

export default castDateStringAsUTC;
